/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import React from 'react';
import { Grid, Row, Column, Button } from '@exo/frontend-components-base';
import { AuthCodeForm } from '@exo/frontend-components-forms';
import { Link, useHistory } from 'react-router-dom';
import { ArrowRight16 } from '@carbon/icons-react';
import * as S from './ResetPassword.styles';
import { ResetPasswordContainerRenderProps } from '@exo/frontend-features-insurance-polaris-login-logic';
import { useIntl } from '@exo/frontend-common-i18n';
import * as yup from 'yup';

const initialValues = {
  userId: '',
  companyEmail: '',
  securityQuestion: '',
  securityAnswer: ''
};

export const ResetPassword = ({
  onSubmit,
  error,
  securityQuestionsData
}: ResetPasswordContainerRenderProps) => {
  const intl = useIntl('features.polaris-login.polaris-login-ui.pages.ResetPasswordPage');
  const history = useHistory();

  const schema = yup.object().shape({
    userId: yup.string().required(intl.msg('form.userId.required', 'Invalid value') as string),
    companyEmail: yup
      .string()
      .required(intl.msg('form.companyEmail.required', 'Invalid value') as string)
      .email(intl.msg('form.companyEmail.format', 'Invalid value23') as string),
    securityQuestionId: yup
      .string()
      .required(intl.msg('form.securityQuestion.required', 'Invalid value') as string),
    securityAnswer: yup
      .string()
      .required(intl.msg('form.securityAnswer.required', 'Invalid value') as string)
  });

  const goToLogin = () => {
    history.goBack();
  };

  const handleFail = (errorResponse) => {
    if(errorResponse == 'Request failed with status code 429'){
      history.push('/auth/reset-password/request/error');
    }
    else{
      history.push('/auth/reset-password/error');
    }
  };

  const handleFormSubmit = async d => {
    const res: any = await onSubmit(d);
    if (res) {
      history.push('/auth/reset-password/success', {
        email: d?.companyEmail
      });
    }
  };

  return (
    <AuthCodeForm
      mode="onSubmit"
      onSubmit={handleFormSubmit}
      error={error}
      onFail={() => handleFail(error)}
      data={initialValues}
      schema={schema}
      intlPrefix="features.polaris-login.polaris-login-ui.pages.ResetPasswordPage"
      securityQuestions={securityQuestionsData?.map(q => ({ name: q.securityQuestionContent, value: q.securityQuestionId })) ?? []}
      renderFooter={() => (
        <Grid>
          <Row>
            <Column>
              <S.FooterText>
                {intl.msg('form.footerText1', '') as string}
                <br />
                <Link
                  target="_blank"
                  to={{
                    pathname: 'https://www.polaris.co.uk/page/imarket-contact-us/'
                  }}
                >
                  https://www.polaris.co.uk/page/imarket-contact-us/
                </Link>
                <br />
                {intl.msg('form.footerText2', '') as string}
              </S.FooterText>
            </Column>
          </Row>
          <Row>
            <Column className="footerBtns">
              <Button
                variant="light"
                label="Cancel"
                className="cancel-button"
                onClick={goToLogin}
              />
              <Button type="submit" variant="light" label="Continue" icon={<ArrowRight16 />} />
            </Column>
          </Row>
        </Grid>
      )}
    />
  );
};
